import { render, staticRenderFns } from "./personWithdrawCard.vue?vue&type=template&id=3e4c8333&scoped=true"
import script from "./personWithdrawCard.vue?vue&type=script&lang=js"
export * from "./personWithdrawCard.vue?vue&type=script&lang=js"
import style0 from "./personWithdrawCard.vue?vue&type=style&index=0&id=3e4c8333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4c8333",
  null
  
)

export default component.exports